import React from 'react'
import styled from 'styled-components'

import { VacanciesProps } from './VacanciesShell'

const Content = styled.div`
  & iframe {
    display: block;
    width: 100%;
    max-width: 100%;
    border: 0;
  }
`

const Embedded: React.FC<VacanciesProps> = ({ fields }) => (
  <section className="py-5">
    <div className="container">
      <Content
      style={{width: '100%'}}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: fields.description || '' }}
      />
    </div>
  </section>
)

export default Embedded
